import { Button, IButtonProps } from '@pinpointhq/thumbtack';
import { useFormikContext } from 'formik';
import * as React from 'react';

interface ISubmitButton extends Pick<IButtonProps, 'disabled' | 'large' | 'text' | 'fill' | 'buttonStyle'> {}

export function SubmitButton({ disabled = false, ...buttonProps }: ISubmitButton) {
  const { isValid, isSubmitting, submitForm } = useFormikContext();

  const props = { large: true, ...buttonProps };
  return <Button disabled={!isValid || disabled} loading={isSubmitting} onClick={submitForm} {...props} />;
}

export default SubmitButton;
